import { FC } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { useLogout } from '@hooks/useLogout';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { useUserActivityTracker } from '@hooks/useUserActivityTracker';
import { useSettingsSlice } from 'src/store-redux/settings/settings.slice';

export const UserActivityTracker: FC = () => {
  const { logout } = useLogout();
  const { handleStillHere, timeTillLogout, prompted } =
    useUserActivityTracker();

  const darkMode = useSettingsSlice(s => s.darkMode);

  return (
    <Modal
      width={440}
      onCancel={handleStillHere}
      darkMode={darkMode}
      open={prompted}
      classNames={{
        wrapper: '!z-[2000]'
      }}
      title='Still working?'
      titleClassName={'!text-left'}
      footer={
        <>
          <Button onClick={logout} className='min-w-[16rem] rounded-lg'>
            Log Out
          </Button>
          <Button
            onClick={handleStillHere}
            className='min-w-[16rem] rounded-lg'
            type='primary'
          >
            Stay Logged In
          </Button>
        </>
      }
    >
      <div>
        <p className='text-center font-nunito'>
          Privacy and security is important to us and you have been gone for a
          while. We will log you out soon unless confirmed otherwise.
        </p>
        <p className='text-center font-nunito'>
          You will be logged-out in {timeTillLogout}
        </p>
      </div>
    </Modal>
  );
};
